/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

interface WorkflowFile {
  draftFsi?: any
  targetFsi?: any
  sourceFsi?: any
}

interface WorkflowDto {
  files?: WorkflowFile[]
}

class WfService {
  static getWorkingFileFromWF = (wfDto: WorkflowDto | null | undefined) => {
    if (!wfDto || !wfDto.files || !Array.isArray(wfDto.files) || wfDto.files.length === 0) {
      return null
    }

    if (wfDto.files[0].draftFsi) {
      return wfDto.files[0].draftFsi
    } else if (wfDto.files[0].targetFsi) {
      return wfDto.files[0].targetFsi
    } else if (wfDto.files[0].sourceFsi) {
      return wfDto.files[0].sourceFsi
    }

    return null
  }

  static getWorkingFsi = (file: WorkflowFile | null | undefined) => {
    if (!file || Object.keys(file).length === 0) {
      return null
    }

    if (file.draftFsi) {
      return file.draftFsi
    } else if (file.targetFsi) {
      return file.targetFsi
    } else if (file.sourceFsi) {
      return file.sourceFsi
    }

    return null
  }
}

export default WfService
